import hyperdom from 'hyperdom'
import range from 'lowscore/range.js'
import pluralize from 'pluralize'
import {partySize} from 'root-config/constants.js'
import * as gtmDataLayer from '../../../analytics/gtm/dataLayer.js'
import format from 'root-core/utils/text/stringFormatFilter.js'
import {Message, MessageTypes} from '../../../message.jsx'
import scroller from '../../../scroller.js'

export default class PartyPicker {
  constructor (options) {
    this.quoteCriteria = options.quoteCriteria
    this.config = options.config
    this.user = options.user
    this.resetExtraStays = options.resetExtraStays
    this.departure = options.departure
    this.childrenAllowed = options.childrenAllowed
    this.errorMessages = this.config.errorMessages

    this.passengerOptions = {
      adults: range(partySize.min, partySize.max + 1).filter(adults => {
        return options.childrenAllowed || this.quoteCriteria.areRoomsAvailableForParty({
          adults: adults,
          children: 0,
        })
      }),
      children: range(0, this.getMaximumChildrenNumber(1) + 1),
      minChildAge: this.departure.childAgeFrom,
      maxChildAge: this.departure.childAgeTo,
      isChildAgeConfirmed: false,
    }
    this.party = this.quoteCriteria.popularParties()[0]
    this.partyValidationErrors = {}
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  updatePassengerOptions () {
    const minAdults = this.getMinimumAdultNumber(this.party.children)
    const maxAdults = this.getMaximumAdultNumber(this.party.children)
    const maxChildren = this.getMaximumChildrenNumber(this.party.adults)

    this.passengerOptions.adults = range(minAdults, maxAdults + 1)
    this.passengerOptions.children = range(0, maxChildren + 1)

    if(this.party.children > maxChildren) {
      this.party.children = maxChildren
    }
  }

  partyChanged () {
    this.updatePassengerOptions()
    this.validateParty(this.party)

    if (!Object.values(this.partyValidationErrors).some(Boolean)) {
      const nightsBeforeNumber = this.quoteCriteria.hotelsBefore.selectedNights.number
      const nightsAfterNumber = this.quoteCriteria.hotelsAfter.selectedNights.number

      this.quoteCriteria.setParty(this.party)
      this.resetExtraStays(nightsBeforeNumber, nightsAfterNumber)
    }
  }

  validateParty (party) {
    const size = party.adults + party.children
    const correctSize = size >= partySize.min && size <= partySize.max

    this.partySizeValidationError = !correctSize
  }

  validateAgeConfirmation () {
    const isChildAgeConfirmed = this.party.children === 0 || this.party.isChildAgeConfirmed

    if(isChildAgeConfirmed) {
      return true
    } else {
      this.ageNotConfirmedError = true
    }
  }

  getMaximumChildrenNumber (adults) {
    if(!adults || adults < partySize.min || adults > partySize.max) {
      return 0
    }

    return (adults * 2 >= 5) ? partySize.max - adults : adults * 2
  }

  getMaximumAdultNumber (children) {
    return partySize.max - children
  }

  getMinimumAdultNumber (children) {
    if (children === 0) {
      return 1
    }
    return Math.ceil(children / 2)
  }

  toogleChildAgeNotConfirmedError () {
    this.showNoChildAgeConfimationError = !this.showNoChildAgeConfimationError
  }

  renderPartyValidationErrors () {
    if (this.partySizeValidationError) {
      return <div id='party-picker__messages' class='party-picker__messages'>
        {
          new Message({
            header: 'Not available',
            message: this.errorMessages.partySize,
            type: MessageTypes.WARNING,
          })
        }
      </div>
    } else if (this.quoteCriteria.noRoomsAvailable) {
      return <div id='party-picker__messages' class='party-picker__messages'>
        {
          new Message({
            header: 'Sorry!',
            message: format(this.config.errorMessages.noRoomsAvailable, this.config.phone.general.split(';').shift()),
            type: MessageTypes.WARNING,
          })
        }
      </div>
    }
  }
  renderAgeNotConfirmedError () {
    if(this.ageNotConfirmedError){
      return <div class="o-form-item__warning">
        { scroller.renderScroller() }
        <span>{format(this.errorMessages.noChildAgeConfimation,this.departure.childAgeFrom, this.departure.childAgeTo)}</span>
      </div>
    }
  }

  render () {
    return <div class={['o-accent-box u-margin-bottom-large', 'party-picker']} data-test='party-picker'>
      <div class='u-clearfix'>
        <div>
          <div className={{'party-picker__categories': this.childrenAllowed}}>
            <div className='party-picker__adults'>
              <div className='party-picker__icon-divider'/>
              <select class='shado o-form-item__txt-input' name='adults' data-test='party-picker-adults' binding={{
                get: () => this.party.adults,
                set: adults => {
                  this.party.adults = adults
                  return this.partyChanged()
                },
              }}>
                {
                  this.passengerOptions.adults.map(number => {
                    return <option value={number}>
                      { pluralize('adult', number, true) }
                    </option>
                  })
                }
              </select>
            </div>
            {this.childrenAllowed ? <div className='party-picker__children'>
              <div className='party-picker__icon-divider'/>
              <select class='shado o-form-item__txt-input' name='children' data-test='party-picker-children' binding={{
                get: () => this.party.children,
                set: children => {
                  this.party.children = children
                  return this.partyChanged()
                },
              }}>
                {
                  this.passengerOptions.children.map(number => {
                    return <option value={number}>
                      { pluralize('child', number, true) }
                    </option>
                  })
                }
              </select>
            </div>
              :''}
          </div>
          { this.renderPartyValidationErrors() }
        </div>
      </div>
    </div>
  }
}
